import { render, staticRenderFns } from "./WechatOpenGuidePage.vue?vue&type=template&id=0e33754c&scoped=true&"
import script from "./WechatOpenGuidePage.vue?vue&type=script&lang=js&"
export * from "./WechatOpenGuidePage.vue?vue&type=script&lang=js&"
import style0 from "./WechatOpenGuidePage.vue?vue&type=style&index=0&id=0e33754c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e33754c",
  null
  
)

export default component.exports